(function($) {
// Show Apple Pay on checkout only if it is used as a shipping method and the browser supports it
    $(document).gp_ready(function(){
        let browserSupportsApplePay = false;
        let applePayListItem = $('.show-if-apple_pay_available');
        if (applePayListItem.length > 0){

            function maybeShowApplePay(){
                let applePayListItem = $('.show-if-apple_pay_available');

                if (browserSupportsApplePay){
                    applePayListItem.show();
                }
                else {
                    applePayListItem.remove();
                }
            }

            // Determine Apple Pay support
            if (window.ApplePaySession) {

                if (window.location.protocol === "https:"){
                    // canMakePayments() check requires HTTPS
                    if (window.ApplePaySession.canMakePayments()){
                        browserSupportsApplePay = true;
                    }
                }
                else if (window.location.protocol === "http:") {
                    // for localhost testing
                    browserSupportsApplePay = true;
                }

                if (browserSupportsApplePay){
                    // Show Apple Pay on checkout page load
                    maybeShowApplePay();
                }
            }

            /* If Apple Pay is not supported in the current browser and is the first shipping method in the list
               or was used in the previous order (thus is selected by default),
               select the next or previous method as Apple Pay will be hidden */
            if (!browserSupportsApplePay){
                let applePayInput = applePayListItem.find('input[type="radio"]');

                if (applePayInput.is(":checked")){
                    let nextPaymentMethod = applePayListItem.next();

                    // Select the next payment method if there is one
                    if (nextPaymentMethod.length > 0){
                        let nextPaymentMethodInput = nextPaymentMethod.find('input[type="radio"]');
                        nextPaymentMethodInput.prop("checked", true).trigger("click");
                    }
                    // If not, select the previous payment method
                    else {
                        let prevPaymentMethod = applePayListItem.prev();
                        if (prevPaymentMethod.length > 0){
                            let prevPaymentMethodInput = prevPaymentMethod.find('input[type="radio"]');
                            prevPaymentMethodInput.prop("checked", true).trigger("click");
                        }
                    }
                }

                applePayListItem.remove();
            }
        }

        // Google Pay support
        let browserSupportsGooglePay = null;
        let googlePayListItem = $('.show-if-google_pay_available');
        if (googlePayListItem.length > 0){
            if(browserSupportsGooglePay){
                googlePayListItem.show();
            }

            async function maybeShowGooglePay(){
                if(browserSupportsGooglePay === null){
                    browserSupportsGooglePay = await checkGooglePayAvailability();
                }

                let googlePayListItem = $('.show-if-google_pay_available');

                if (browserSupportsGooglePay){
                    googlePayListItem.show();
                }
                else {
                    googlePayListItem.remove();
                }
            }

            // Determine Google Pay support
            async function checkGooglePayAvailability() {
                // Check Payment Request API support
                if (!window.PaymentRequest) {
                    return false;
                }

                // Payment method definition for Google Pay
                const supportedInstruments = [{
                    supportedMethods: 'https://google.com/pay',
                    data: {
                        apiVersion: 2,
                        apiVersionMinor: 0,
                        allowedPaymentMethods: [{
                            type: 'CARD',
                            parameters: {
                                allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                                allowedCardNetworks: ['MASTERCARD', 'VISA', 'AMEX']
                            }
                        }]
                    }
                }];

                // Basic details about payment (API requires it even for a test)
                const details = {
                    total: {
                        label: 'Test check',
                        amount: { currency: ghostpress_child_params.currency, value: '1.00' }
                    }
                };

                try {
                    // Create a request instance
                    const request = new PaymentRequest(supportedInstruments, details);

                    return await request.canMakePayment();

                } catch (error) {
                    console.error("Error while checking payment method:", error);
                    return false;
                }
            }
            maybeShowGooglePay();
        }

        // Change required phone number pattern based on selected country code
        $('select#billing_phone_country_code').on('change', function(){
            const selected_country_phone_code = $(this).val()
            const $billing_phone = $('input#billing_phone')
            if ($billing_phone){
                const $option_phone_code = $(this).find('option[value="' + selected_country_phone_code + '"]')
                if ($option_phone_code && $option_phone_code.data('pattern')){
                    $billing_phone.attr('pattern', $option_phone_code.data('pattern'))
                }
            }
        })
    });
})(jQuery);

